import React, { useState } from 'react';
import './navigation.css';
const Navigation = ({ onOpenAbout, onOpenContact }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleScroll = (id) => (e) => {
    e.preventDefault();
    const el = document.querySelector(id);
    const headerOffset = 0; // hauteur du header
    if (el) {
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      setMobileMenuOpen(false); // ferme le menu mobile si ouvert
    }
  };

  return (
    <div className="navigation-container1">
      <nav aria-label="Navigation principale" className="navigation">

        <div className="navigation-mobile-header">
          <div className="navigation-mobile-header">
            <a href="#accueil" className="navigation-mobile-logo">
              <img
                src="/logo.png"
                alt="Logo Gaëtan Crabeels, développeur web"
                id="Logo"
                className="section-title"
              />
            </a>
          </div>
          {/* Desktop Links */}
          <div className="navigation-links">
            <a href="#accueil" onClick={handleScroll('#accueil')}>
              <div className="navigation-link"><span>Accueil</span></div>
            </a>
            <a href="#services" onClick={handleScroll('#services')}>
              <div className="navigation-link"><span>Services</span></div>
            </a>
            <a href="#Process" onClick={handleScroll('#Process')}>
              <div className="navigation-link"><span>Process</span></div>
            </a>
            <div
              className="navigation-link"
              role="button"
              tabIndex={0}
              onClick={onOpenAbout}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onOpenAbout();
              }}
            >
              <span>À Propos</span>
            </div>
            <a href="#contact" onClick={handleScroll('#contact')}>
              <div className="navigation-link"><span>Contact</span></div>
            </a>
              <div
                className="navigation-cta btn btn-primary"
                role="button"
                tabIndex={0}
                onClick={onOpenContact}
              >
                <span>Démarrer un projet</span>
              </div>
          </div>

          {/* Hamburger toggle */}
          <button
            className="navigation-toggle"
            aria-label={mobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              ) : (
                <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              )}
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`navigation-mobile-overlay ${mobileMenuOpen ? 'navigation-mobile-active' : ''}`}>
        <div className="navigation-mobile-header">
          <a href="#accueil" onClick={handleScroll('#accueil')} className="navigation-mobile-logo">
            <span className="section-title">Gaëtan Crabeels</span>
          </a>
          <button
            className="navigation-mobile-close"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="Fermer le menu"
          >
            ✕
          </button>
        </div>
        <div className="navigation-mobile-content">
          <a href="#accueil" onClick={handleScroll('#accueil')} className="navigation-mobile-link">Accueil</a>
          <a href="#services" onClick={handleScroll('#services')} className="navigation-mobile-link">Services</a>
          <a href="#realisations" onClick={handleScroll('#realisations')} className="navigation-mobile-link">Réalisations</a>
          <div
            className="navigation-mobile-link"
            role="button"
            tabIndex={0}
            onClick={() => { onOpenAbout(); setMobileMenuOpen(false); }}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { onOpenAbout(); setMobileMenuOpen(false); } }}
          >
            À Propos
          </div>
          <a href="#contact" onClick={handleScroll('#contact')} className="navigation-mobile-link">Contact</a>
          <div
                className="navigation-cta btn btn-primary"
                role="button"
                tabIndex={0}
                onClick={onOpenContact}
              >
                <span>Démarrer un projet</span>
              </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
